/**
 * Ce que l'outil des mentions légales sait d'avance : les hébergeurs, les
 * outils qu'un site charge, et ce que chaque collecte de données implique.
 *
 * TOUT CE QUI EST ÉCRIT ICI A ÉTÉ LU À LA SOURCE, le 30 octobre 2026 : la
 * raison sociale et l'adresse d'un hébergeur sur sa propre page légale, une
 * durée de conservation dans un texte de la CNIL. Chaque entrée nomme sa
 * source, que lib/tools/sourcesWebsite.js décrit et que la veille relit.
 *
 * L'ENTITÉ QUI COMPTE EST CELLE QUI CONTRACTE AVEC UN CLIENT EN FRANCE. Un
 * même service change souvent de société selon le pays du client : AWS facture
 * l'Europe depuis le Luxembourg, Shopify depuis l'Irlande, Heroku un client
 * français depuis Paris. C'est celle-là que les mentions doivent nommer, et
 * c'est elle qui décide s'il y a un transfert hors de l'Union.
 *
 * LE TÉLÉPHONE N'EST LÀ QUE S'IL EST PUBLIÉ. La loi demande celui de
 * l'hébergeur, mais la plupart n'en publient aucun. `telephone: null` dit
 * précisément cela, et le parcours le demande alors au lecteur, qui le trouve
 * dans son contrat ou en le demandant. Nous ne recopions pas celui d'un
 * annuaire, qui peut être celui du service commercial d'une autre filiale.
 */

/* --------------------------------------------------------------------- */
/* Les hébergeurs                                                         */
/* --------------------------------------------------------------------- */

export const HEBERGEURS = {
    vercel: {
        nom: "Vercel",
        pour: "Next.js, sites statiques",
        pourEn: "Next.js, static sites",
        raisonSociale: "Vercel Inc.",
        adresse: "440 N Barranca Avenue #4133, Covina, CA 91723, États-Unis",
        telephone: null,
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_vercel",
    },
    netlify: {
        nom: "Netlify",
        pour: "Sites statiques, Jamstack",
        pourEn: "Static sites, Jamstack",
        raisonSociale: "Netlify, Inc.",
        adresse: "101 2nd Street, San Francisco, CA 94105, États-Unis",
        telephone: null,
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_netlify",
    },
    ovhcloud: {
        nom: "OVHcloud",
        pour: "Hébergement web, serveurs",
        pourEn: "Web hosting, servers",
        raisonSociale: "OVH SAS",
        adresse: "2 rue Kellermann, 59100 Roubaix, France",
        telephone: null,
        pays: "France",
        horsUe: false,
        source: "hebergeur_ovhcloud",
    },
    o2switch: {
        nom: "o2switch",
        pour: "Hébergement web mutualisé",
        pourEn: "Shared web hosting",
        raisonSociale: "o2switch",
        adresse: "Chemin des Pardiaux, 63000 Clermont-Ferrand, France",
        telephone: "04 44 44 60 40",
        pays: "France",
        horsUe: false,
        source: "hebergeur_o2switch",
    },
    hostinger: {
        nom: "Hostinger",
        pour: "Hébergement web mutualisé",
        pourEn: "Shared web hosting",
        raisonSociale: "Hostinger International Limited",
        adresse: "61 Lordou Vironos str., 6023 Larnaca, Chypre",
        telephone: null,
        pays: "Chypre",
        horsUe: false,
        source: "hebergeur_hostinger",
    },
    ionos: {
        nom: "IONOS",
        pour: "Hébergement web, serveurs",
        pourEn: "Web hosting, servers",
        raisonSociale: "IONOS SARL",
        adresse: "7, place de la Gare, BP 70109, 57200 Sarreguemines Cedex, France",
        telephone: "0970 808 911",
        pays: "France",
        horsUe: false,
        source: "hebergeur_ionos",
    },
    wix: {
        nom: "Wix",
        pour: "Constructeur de sites",
        pourEn: "Website builder",
        raisonSociale: "Wix.com Ltd.",
        adresse: "5 Yunitzman St., Tel-Aviv, Israël",
        telephone: null,
        pays: "Israël",
        horsUe: true,
        source: "hebergeur_wix",
    },
    shopify: {
        nom: "Shopify",
        pour: "Boutique en ligne",
        pourEn: "Online shop",
        raisonSociale: "Shopify International Limited",
        adresse: "The Sidings, 4th Floor, Grand Canal Quay, Dublin D02 E7K8, Irlande",
        telephone: null,
        pays: "Irlande",
        horsUe: false,
        source: "hebergeur_shopify",
    },
    squarespace: {
        nom: "Squarespace",
        pour: "Constructeur de sites",
        pourEn: "Website builder",
        raisonSociale: "Squarespace Ireland Limited",
        adresse: "Squarespace House, Ship Street Great, Dublin 8, D08 N12C, Irlande",
        telephone: null,
        pays: "Irlande",
        horsUe: false,
        source: "hebergeur_squarespace",
    },
    webflow: {
        nom: "Webflow",
        pour: "Constructeur de sites",
        pourEn: "Website builder",
        raisonSociale: "Webflow, Inc.",
        adresse: "398 11th Street, Floor 2, San Francisco, CA 94103, États-Unis",
        telephone: null,
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_webflow",
    },
    wordpressCom: {
        nom: "WordPress.com",
        pour: "Blog et site WordPress hébergé",
        pourEn: "Hosted WordPress blog and site",
        raisonSociale: "Aut O'Mattic A8C Ireland Ltd.",
        adresse: "Grand Canal Dock, 25 Herbert Pl, Dublin, D02 AY86, Irlande",
        telephone: null,
        pays: "Irlande",
        horsUe: false,
        source: "hebergeur_wordpress_com",
    },
    githubPages: {
        nom: "GitHub Pages",
        pour: "Sites statiques",
        pourEn: "Static sites",
        raisonSociale: "GitHub, Inc.",
        adresse: "88 Colin P. Kelly Jr. St., San Francisco, CA 94107, États-Unis",
        telephone: null,
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_github",
    },
    render: {
        nom: "Render",
        pour: "Serveur, API, base de données",
        pourEn: "Server, API, database",
        raisonSociale: "Render Services, Inc.",
        adresse: "525 Brannan St, San Francisco, CA 94131, États-Unis",
        telephone: null,
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_render",
    },
    railway: {
        nom: "Railway",
        pour: "Serveur, API, base de données",
        pourEn: "Server, API, database",
        raisonSociale: "Railway Corporation",
        adresse: "548 Market St Suite 68956, San Francisco, California 94104, États-Unis",
        telephone: "(415) 707-7675",
        pays: "États-Unis",
        horsUe: true,
        source: "hebergeur_railway",
    },
    supabase: {
        nom: "Supabase",
        pour: "Base de données, authentification",
        pourEn: "Database, authentication",
        raisonSociale: "Supabase Pte. Ltd.",
        adresse: "65 Chulia Street #38-02/03, OCBC Centre, Singapore 049513, Singapour",
        telephone: null,
        pays: "Singapour",
        horsUe: true,
        source: "hebergeur_supabase",
    },
    aws: {
        nom: "Amazon Web Services",
        pour: "Serveurs, fichiers (S3)",
        pourEn: "Servers, files (S3)",
        raisonSociale: "Amazon Web Services EMEA SARL",
        adresse: "38 Avenue John F. Kennedy, L-1855 Luxembourg",
        telephone: null,
        pays: "Luxembourg",
        horsUe: false,
        source: "hebergeur_aws",
    },
    googleCloud: {
        nom: "Google Cloud",
        pour: "Serveurs, Firebase en offre payante",
        pourEn: "Servers, paid Firebase plans",
        raisonSociale: "Google Cloud France",
        adresse: "8 Rue de Londres, 75009 Paris, France",
        telephone: null,
        pays: "France",
        horsUe: false,
        source: "hebergeur_google_cloud",
    },
    scaleway: {
        nom: "Scaleway",
        pour: "Serveurs, fichiers",
        pourEn: "Servers, files",
        raisonSociale: "Scaleway SAS",
        adresse: "8, rue de la Ville-l'Évêque, 75008 Paris, France",
        telephone: null,
        pays: "France",
        horsUe: false,
        source: "hebergeur_scaleway",
    },
    infomaniak: {
        nom: "Infomaniak",
        pour: "Hébergement web, serveurs",
        pourEn: "Web hosting, servers",
        raisonSociale: "Infomaniak Network SA",
        adresse: "Rue Eugène Marziano 25, 1227 Les Acacias (GE), Suisse",
        telephone: null,
        pays: "Suisse",
        horsUe: true,
        source: "hebergeur_infomaniak",
    },
};

/**
 * Ce qu'un hébergeur porte, quand ils sont plusieurs.
 *
 * `phrase` ouvre son paragraphe dans les mentions légales ; `destinataire`
 * dit son rôle dans la liste des destinataires de la politique.
 */
export const ROLES_HEBERGEMENT = {
    site: {
        fr: "Tout le site",
        en: "The whole site",
        phrase: "Le site est hébergé par :",
        destinataire: "hébergement du site",
    },
    front: {
        fr: "L'interface",
        en: "The front end",
        phrase: "L'interface du site est hébergée par :",
        destinataire: "hébergement de l'interface du site",
    },
    back: {
        fr: "Le serveur et l'API",
        en: "The server and API",
        phrase: "Le serveur et l'API du site sont hébergés par :",
        destinataire: "hébergement du serveur du site",
    },
    base: {
        fr: "La base de données",
        en: "The database",
        phrase: "La base de données du site est hébergée par :",
        destinataire: "hébergement de la base de données",
    },
    fichiers: {
        fr: "Les fichiers et médias",
        en: "Files and media",
        phrase: "Les fichiers et médias du site sont hébergés par :",
        destinataire: "stockage des fichiers et médias",
    },
};

/* --------------------------------------------------------------------- */
/* Les traitements                                                        */
/* --------------------------------------------------------------------- */

/**
 * Ce que chaque collecte implique, écrit pour le visiteur.
 *
 * LES DURÉES VIENNENT DE LA CNIL, ET LÀ OÙ ELLE N'EN FIXE PAS, ON LE DIT.
 * Aucun texte ne chiffre la durée d'un message de contact : Service Public
 * parle du « temps nécessaire » à son traitement, et le référentiel de la
 * CNIL prend le relais quand l'auteur devient un client potentiel. La phrase
 * reprend ces deux temps plutôt qu'un chiffre inventé.
 *
 * `categorieOutil` relie le traitement aux outils qui le servent : une
 * newsletter envoyée avec Brevo le dit, un paiement passé par Stripe aussi.
 */
export const TRAITEMENTS = {
    contact: {
        titre: "Quand vous écrivez par le formulaire de contact",
        donnees: "votre nom, votre adresse électronique et votre message, et ce que vous choisissez d'y ajouter",
        obligatoire: "votre adresse électronique et votre message, sans lesquels nous ne pouvons pas vous répondre ; le reste est facultatif",
        finalite: "vous répondre",
        base: "notre intérêt légitime à répondre aux personnes qui nous contactent",
        duree:
            "le temps nécessaire pour traiter votre demande ; si elle porte sur nos services, trois ans après le dernier contact venu de vous",
        categorieOutil: null,
        sources: ["donnees_contact_duree", "donnees_prospects_duree"],
    },
    newsletter: {
        titre: "Quand vous vous inscrivez à la lettre d'information",
        donnees: "votre adresse électronique, et votre prénom si vous le donnez",
        obligatoire: "votre adresse électronique ; le prénom est facultatif",
        finalite: "vous envoyer la lettre d'information",
        base:
            "votre consentement, que vous retirez à tout moment par le lien de désinscription présent dans chaque envoi",
        duree: "jusqu'à votre désinscription, ou trois ans après le dernier contact venu de vous",
        categorieOutil: "emailing",
        sources: ["donnees_prospection_consentement", "donnees_prospects_duree"],
    },
    compte: {
        titre: "Quand vous créez un compte",
        donnees: "votre nom, votre adresse électronique, votre mot de passe sous une forme protégée et l'historique de votre compte",
        obligatoire: "votre adresse électronique et un mot de passe, sans lesquels le compte ne peut pas être créé",
        finalite: "vous donner accès à votre espace et aux services qui y sont attachés",
        base: "l'exécution du contrat qui vous lie à nous quand vous créez votre compte",
        duree: "tant que votre compte est actif ; un compte inutilisé pendant deux ans est supprimé, après vous en avoir prévenu",
        categorieOutil: null,
        sources: ["donnees_compte_inactif"],
    },
    commandes: {
        titre: "Quand vous commandez et payez en ligne",
        donnees: "votre nom, vos adresses de facturation et de livraison, votre adresse électronique, le détail de vos commandes et vos factures",
        obligatoire: "tout ce qui précède, sans quoi la commande ne peut être ni livrée ni facturée",
        finalite: "traiter, livrer et facturer vos commandes",
        base: "l'exécution du contrat de vente, et nos obligations comptables pour les factures",
        duree:
            "le temps de la relation commerciale ; les factures et pièces comptables sont gardées dix ans, comme l'impose le code de commerce",
        categorieOutil: "paiement",
        complement:
            "Les données de votre carte bancaire sont saisies chez notre prestataire de paiement et ne nous sont pas transmises. Elles ne sont pas conservées au-delà de la transaction, sauf si vous demandez à enregistrer votre carte pour vos prochains achats, ou pour traiter une contestation : treize mois après la date de débit, quinze mois pour une carte à débit différé.",
        complementSiPaiement: true,
        sources: ["donnees_clients_duree", "donnees_pieces_comptables", "donnees_carte_bancaire"],
    },
    rendezVous: {
        titre: "Quand vous prenez rendez-vous",
        donnees: "votre nom, votre adresse électronique, votre téléphone si vous le donnez, et le créneau choisi",
        obligatoire: "votre nom, votre adresse électronique et le créneau ; le téléphone est facultatif",
        finalite: "organiser le rendez-vous et vous le rappeler",
        base: "les mesures prises à votre demande avant un éventuel contrat",
        duree:
            "le temps nécessaire au rendez-vous ; si vous n'êtes pas encore client, trois ans après le dernier contact venu de vous",
        categorieOutil: "rendezVous",
        sources: ["donnees_contact_duree", "donnees_prospects_duree"],
    },
    discussion: {
        titre: "Quand vous nous écrivez dans la fenêtre de discussion",
        donnees: "vos messages, votre adresse électronique si vous la donnez, et les informations techniques de la conversation",
        obligatoire: "rien, en dehors des messages que vous choisissez d'envoyer",
        finalite: "vous répondre en direct",
        base: "notre intérêt légitime à répondre aux personnes qui nous contactent",
        duree:
            "le temps nécessaire pour traiter votre demande ; si elle porte sur nos services, trois ans après le dernier contact venu de vous",
        categorieOutil: "echange",
        sources: ["donnees_contact_duree", "donnees_prospects_duree"],
    },
};

/* --------------------------------------------------------------------- */
/* Les outils qu'un site charge                                           */
/* --------------------------------------------------------------------- */

/**
 * Les outils, par ce qu'ils imposent au visiteur.
 *
 * `cookies` vaut :
 *   - "consentement" : la CNIL demande l'accord avant tout dépôt (publicité,
 *     contenu d'un tiers intégré, outil qui réutilise les données) ;
 *   - "reglage" : exempté seulement s'il est réglé comme il faut, et c'est le
 *     lecteur qui dit s'il l'est (`conditions` lui dit quoi vérifier) ;
 *   - "aucun" : l'outil ne dépose rien chez le visiteur, mais il reçoit des
 *     données et figure donc parmi les destinataires.
 *
 * `societe` est l'entité que l'outil nomme lui-même pour un client européen.
 * Quand il renvoie au contrat signé (Google Ads), la phrase le dit au lieu de
 * choisir pour lui. Un outil installé sur le serveur du site n'en a pas
 * (`societe: null`) : ses données restent chez l'hébergeur, déjà nommé.
 *
 * CE QUI N'EST PAS RELEVÉ MOT POUR MOT, ET COMMENT ON L'A TRANCHÉ :
 *   - YouTube, Google Maps, reCAPTCHA et Google Fonts ne nomment pas d'entité
 *     sur leurs pages : on applique la règle générale de Google, qui désigne
 *     Google Ireland Limited pour les utilisateurs de l'Espace économique
 *     européen (source `outil_google`) ;
 *   - la page de Meta ne se lit pas sans navigateur : Meta Ireland Limited et
 *     Meta Platforms, Inc. y ont été relevés à la main le 30/10/2026 ;
 *   - aucun texte de la CNIL ne traite des fenêtres de discussion : Crisp et
 *     Intercom sont comptés dans le bandeau par la règle générale (un traceur
 *     déposé avant que le visiteur n'ait rien demandé n'est pas nécessaire).
 *
 * Deux outils manquent faute d'avoir pu lire leurs pages le 30/10/2026 :
 * Vimeo (pages légales derrière un CAPTCHA) et Hotjar (fondu dans
 * Contentsquare, sans entité nommée pour un client européen).
 */
export const OUTILS_TIERS = {
    googleAnalytics: {
        nom: "Google Analytics",
        societe: "Google Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        propreCompte: true,
        categorie: "audience",
        usage: "mesure d'audience (Google Analytics)",
        cookies: "consentement",
        finaliteTraceur: "mesure de la fréquentation du site, avec des données que Google réutilise pour son propre compte",
        source: "outil_google_analytics",
    },
    matomo: {
        nom: "Matomo (installé sur le serveur du site)",
        nomEn: "Matomo (on the site's own server)",
        societe: null,
        pays: "",
        horsUe: false,
        categorie: "audience",
        usage: "mesure d'audience",
        cookies: "reglage",
        finaliteTraceur: "mesure de la fréquentation du site, en statistiques anonymes",
        finaliteSansReglage: "mesure de la fréquentation du site",
        conditions: {
            fr: "Exempté s'il suit le guide de configuration de Matomo hébergé par la CNIL : adresses IP anonymisées, aucun suivi entre domaines, pas d'identifiant d'utilisateur, pas de suivi du commerce en ligne, ni carte de chaleur ni enregistrement de session, et un moyen de refuser la mesure.",
            en: "Exempt if it follows the Matomo configuration guide hosted by the CNIL: anonymised IP addresses, no cross-domain tracking, no user ID, no e-commerce tracking, no heatmaps or session recordings, and a way to opt out.",
        },
        source: "cookies_matomo",
    },
    matomoCloud: {
        nom: "Matomo Cloud",
        societe: "InnoCraft Limited",
        pays: "Nouvelle-Zélande",
        horsUe: true,
        categorie: "audience",
        usage: "mesure d'audience (Matomo Cloud)",
        cookies: "reglage",
        finaliteTraceur: "mesure de la fréquentation du site, en statistiques anonymes",
        finaliteSansReglage: "mesure de la fréquentation du site",
        conditions: {
            fr: "Exempté s'il suit le guide de configuration de Matomo hébergé par la CNIL : adresses IP anonymisées, aucun suivi entre domaines, pas d'identifiant d'utilisateur, pas de suivi du commerce en ligne, ni carte de chaleur ni enregistrement de session, et un moyen de refuser la mesure.",
            en: "Exempt if it follows the Matomo configuration guide hosted by the CNIL: anonymised IP addresses, no cross-domain tracking, no user ID, no e-commerce tracking, no heatmaps or session recordings, and a way to opt out.",
        },
        source: "outil_matomo_cloud",
    },
    plausible: {
        nom: "Plausible Analytics",
        societe: "Plausible Insights OÜ",
        pays: "",
        horsUe: false,
        categorie: "audience",
        usage: "mesure d'audience (Plausible Analytics)",
        // Sa documentation dit qu'il ne dépose aucun cookie ni identifiant :
        // rien à consentir, mais il reçoit les visites, et il est nommé.
        cookies: "aucun",
        finaliteTraceur: "",
        source: "outil_plausible",
    },
    metaPixel: {
        nom: "Pixel Meta",
        nomEn: "Meta pixel",
        societe: "Meta Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        propreCompte: true,
        categorie: "publicite",
        usage: "mesure et ciblage publicitaires, en responsable conjoint du traitement avec nous pour la collecte",
        aussi: [
            {
                societe: "Meta Platforms, Inc.",
                pays: "États-Unis",
                horsUe: true,
                usage: "réception des données transmises par le pixel, en responsable indépendant",
            },
        ],
        cookies: "consentement",
        finaliteTraceur: "mesure et ciblage des publicités sur Facebook et Instagram",
        // La page de Meta ne se lit pas sans navigateur : l'entité a été relevée
        // à la main le 30/10/2026 (conditions des outils professionnels de Meta,
        // en vigueur depuis le 3 novembre 2025). Le verdict suit la CNIL.
        source: "cookies_reseaux_sociaux",
    },
    googleAds: {
        nom: "Google Ads",
        societe: "Google Ireland Limited ou Google LLC, selon le contrat",
        pays: "",
        horsUe: true,
        propreCompte: true,
        categorie: "publicite",
        usage: "mesure et ciblage publicitaires (Google Ads)",
        cookies: "consentement",
        finaliteTraceur: "mesure des conversions et ciblage des publicités Google",
        source: "outil_google_ads",
    },
    youtube: {
        nom: "YouTube (vidéos intégrées)",
        nomEn: "YouTube (embedded videos)",
        societe: "Google Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        propreCompte: true,
        categorie: "video",
        usage: "lecture des vidéos YouTube intégrées",
        cookies: "consentement",
        finaliteTraceur: "lecture des vidéos YouTube, et traceurs que YouTube dépose dès leur chargement",
        source: "outil_google",
    },
    googleMaps: {
        nom: "Google Maps (carte intégrée)",
        nomEn: "Google Maps (embedded map)",
        societe: "Google Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        propreCompte: true,
        categorie: "video",
        usage: "affichage de la carte Google Maps",
        cookies: "consentement",
        finaliteTraceur: "affichage de la carte, et traceurs que Google dépose dès son chargement",
        source: "outil_google",
    },
    calendly: {
        nom: "Calendly",
        societe: "Calendly LLC",
        pays: "États-Unis",
        horsUe: true,
        categorie: "rendezVous",
        usage: "prise de rendez-vous (Calendly)",
        cookies: "consentement",
        finaliteTraceur: "affichage de l'agenda de réservation intégré",
        source: "outil_calendly",
    },
    stripe: {
        nom: "Stripe",
        societe: "Stripe Payments Europe Limited",
        pays: "Irlande",
        horsUe: false,
        categorie: "paiement",
        usage: "paiement en ligne (Stripe)",
        cookies: "reglage",
        finaliteTraceur: "sécurisation du paiement et détection de la fraude",
        finaliteExemptee: "fonctionnement du paiement que vous effectuez",
        conditions: {
            fr: "Stripe range ses cookies parmi les essentiels, lutte contre la fraude comprise, mais la CNIL n'exempte pas la lutte contre la fraude en général. Chargé seulement au moment du paiement, il sert ce que le visiteur demande ; chargé sur toutes les pages, comptez-le dans le bandeau.",
            en: "Stripe counts its cookies as essential, fraud prevention included, but the CNIL does not exempt fraud prevention in general. Loaded only at payment, it serves what the visitor asks for; loaded on every page, count it in the banner.",
        },
        source: "outil_stripe",
    },
    brevo: {
        nom: "Brevo",
        societe: "Brevo",
        pays: "France",
        horsUe: false,
        categorie: "emailing",
        usage: "envoi de la lettre d'information (Brevo)",
        cookies: "aucun",
        finaliteTraceur: "",
        source: "outil_brevo",
    },
    mailchimp: {
        nom: "Mailchimp",
        societe: "The Rocket Science Group LLC (Mailchimp)",
        pays: "États-Unis",
        horsUe: true,
        categorie: "emailing",
        usage: "envoi de la lettre d'information (Mailchimp)",
        cookies: "aucun",
        finaliteTraceur: "",
        source: "outil_mailchimp",
    },
    crisp: {
        nom: "Crisp",
        societe: "Crisp IM SAS",
        pays: "France",
        horsUe: false,
        categorie: "echange",
        usage: "discussion en direct avec les visiteurs (Crisp)",
        cookies: "consentement",
        finaliteTraceur: "fenêtre de discussion et suivi de la conversation",
        source: "outil_crisp",
    },
    intercom: {
        nom: "Intercom",
        societe: "Intercom R&D Unlimited Company",
        pays: "Irlande",
        horsUe: false,
        categorie: "echange",
        usage: "discussion en direct avec les visiteurs (Intercom)",
        cookies: "consentement",
        finaliteTraceur: "fenêtre de discussion et suivi de la conversation",
        source: "outil_intercom",
    },
    recaptcha: {
        nom: "reCAPTCHA",
        societe: "Google Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        propreCompte: true,
        categorie: "technique",
        usage: "protection des formulaires contre les robots (reCAPTCHA)",
        cookies: "consentement",
        finaliteTraceur: "protection des formulaires, avec des données que Google réutilise",
        source: "outil_recaptcha",
    },
    googleFonts: {
        nom: "Google Fonts (polices chargées depuis Google)",
        nomEn: "Google Fonts (loaded from Google)",
        societe: "Google Ireland Limited",
        pays: "Irlande",
        horsUe: false,
        categorie: "technique",
        usage: "affichage des polices de caractères, qui transmet l'adresse IP du visiteur à Google",
        cookies: "aucun",
        finaliteTraceur: "",
        source: "outil_google",
    },
};
